import type { EquipmentKind } from '@cadencia/contracts';
import type { MovementPattern, Muscle } from './muscles.js';

/**
 * Forma de un ejercicio del catalogo y el constructor con sus valores por
 * defecto. Vive aparte de `exercises.ts` para que la biblioteca
 * (`exercise-library.ts`) pueda usarlo sin un import circular.
 */

export type ResistanceProfile = 'ascending' | 'descending' | 'bell' | 'flat' | 'variable';
export type StretchEmphasis = 'lengthened' | 'mid' | 'shortened';

export interface Exercise {
  slug: string;
  nameEs: string;
  pattern: MovementPattern;
  primaryMuscles: Muscle[];
  secondaryMuscles: Muscle[];
  equipmentKind: EquipmentKind;
  isUnilateral: boolean;
  resistanceProfile: ResistanceProfile;
  stretchEmphasis: StretchEmphasis;
  /** 1 = trivial, 5 = muy exigente tecnicamente. */
  technicalDemand: number;
  /** 1 = sin carga axial, 5 = coste sistemico alto. */
  axialLoad: number;
  isCompound: boolean;
  defaultRestSeconds: number;
}

export type ExerciseOptions = Partial<
  Omit<Exercise, 'slug' | 'nameEs' | 'pattern' | 'primaryMuscles' | 'secondaryMuscles' | 'equipmentKind'>
>;

export const E = (
  slug: string,
  nameEs: string,
  pattern: MovementPattern,
  primaryMuscles: Muscle[],
  secondaryMuscles: Muscle[],
  equipmentKind: EquipmentKind,
  opts: ExerciseOptions = {},
): Exercise => ({
  slug,
  nameEs,
  pattern,
  primaryMuscles,
  secondaryMuscles,
  equipmentKind,
  isUnilateral: opts.isUnilateral ?? false,
  resistanceProfile: opts.resistanceProfile ?? 'flat',
  stretchEmphasis: opts.stretchEmphasis ?? 'mid',
  technicalDemand: opts.technicalDemand ?? 2,
  axialLoad: opts.axialLoad ?? 2,
  isCompound: opts.isCompound ?? false,
  defaultRestSeconds: opts.defaultRestSeconds ?? 90,
});
